<script>
  import { modal } from 'vue-strap';

  export default {
    components: { modal },
    props: ['mostrar', 'id', 'salvando', 'liberando', 'mensagem', 'instrucao', 'dataLimite'],
    data() {
      return {
        confirmando: false,
        mostrarInstrucao: this.instrucao !== null && this.instrucao !== undefined && this.instrucao !== '',
      }
    },
    methods: {
      confirmar() {
        this.confirmando = true;
      },
      permitirBotaoLiberar() {
        if (this.dataLimite) {
          return (this.dataLimite && moment(this.dataLimite).add(1, "d").diff(moment()) > 0);
        }
        return true;
      }
    },
    computed: {
      show() {
        this.confirmando = false;
        return this.mostrar;
      },
    }
  }
</script>

<template>
  <div>
    <modal ref="modal"
           :value="show"
           effect="fade"
           @closed="$emit('fechado')"
           :backdrop="!salvando">
      <div slot="modal-header" class="modal-header hide"></div>

      <div class="swal2-icon swal2-question" style="display: block;">?</div>

      <h3 class="text-center" v-if="!confirmando">
        Deseja liberar ou cancelar a solicitação número
        {{ id || '' }}?
      </h3>

      <div v-if="mostrarInstrucao">
        <br />
        <h4>Instruções:</h4>
        <div v-html="instrucao" />
      </div>

      <div v-if="!permitirBotaoLiberar()">
        <br />
        <h4 style="color: darkred;">Período de liberação fechado.</h4>
      </div>

      <div slot="modal-footer" class="modal-footer" v-if="!confirmando">
        <button type="button" class="btn btn-primary" :disabled="salvando" style="margin-bottom: 5px;" @click="$emit('liberar')" v-if="liberando && permitirBotaoLiberar()">
          <i class="fa fa-check"></i> Liberar
        </button>

        <button type="button" class="btn btn-primary" :disabled="salvando" style="margin-bottom: 5px;" @click="confirmar" v-if="!liberando && permitirBotaoLiberar()">
          <i class="fa fa-check"></i> Liberar
        </button>

        <button type="button" class="btn btn-danger" :disabled="salvando" style="margin-bottom: 5px;" @click="$emit('cancelar')">
          <i class="fa fa-ban"></i> Cancelar
        </button>
        <button type="button" class="btn btn-default" style="margin-bottom: 5px;" @click="$refs.modal.action(false, 3)" :disabled="salvando">
          <i class="fa fa-times"></i> Fechar
        </button>
      </div>

      <div v-if="confirmando">
        <h3 class="text-center">
          <span v-html="mensagem" />
        </h3>
      </div>

      <div slot="modal-footer" class="modal-footer" v-if="confirmando">
        <button type="button" class="btn btn-primary" :disabled="salvando" style="margin-bottom: 5px;" @click="$emit('liberar')">
          <i class="fa fa-check"></i> Confirmar
        </button>
        <button type="button" class="btn btn-default" style="margin-bottom: 5px;" @click="$refs.modal.action(false, 3)" :disabled="salvando">
          <i class="fa fa-times"></i> Cancelar
        </button>
      </div>
    </modal>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/componentes/ModalLiberarCancelar.vue